export default {
  init: function init() {},
  finalize: function finalize() {}
};